import {Weekday, ScheduleState} from '@/entities/campaign/types'; 

export const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

export const AUTO_SCROLL_EDGE_DISTANCE = 96;
export const AUTO_SCROLL_MAX_SPEED = 24;

export const WEEKDAYS: { id: Weekday; label: string }[] = [
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
  { id: 'sunday', label: 'Sunday' },
];

export const markers = [0, 3, 6, 9, 12, 15, 18, 21, 24];

export const getSelectedDays = (scheduling: ScheduleState) =>
  scheduling.enableDayParting ? scheduling.selectedDays || [] : WEEKDAYS.map((d) => d.id);

export const DEFAULT_SCHEDULING: ScheduleState = {
  enableDayParting: false,
  enableTimeParting: false,
  selectedDays: [],
  allDays: [],
  perDaySchedules: {},
};

export const CAMPAIGN_CREATIVE_PAYLOAD_TYPE = {
  PROGRAMMATIC: 'PROGRAMMATIC',
  NON_PROGRAMMATIC: 'NON_PROGRAMMATIC',
} as const;

export const FULL_DAY = [
  {
    start: '00:00',
    end: '24:00',
  },
];
